import React, { FC } from 'react';

import PaymentMethodSelect, { HoverTheme } from 'components/payment-method-select';
import Toggle from 'components/toggle';

import { ScanAndPayLayout } from './components/scan-and-pay-layout';
import { ScanAndPayLayoutSkeleton } from './components/scan-and-pay-layout/scan-and-pay-layout.skeleton';
import NoPaymentMethod from './no-payment-method';
import { ScanAndPayContentSkeleton } from './scan-and-pay-content.skeleton';
import { StyledSanityBlockContent } from './th-scan-and-pay.styled';
import { ITHScanAndPayViewProps, ScanAndPayViews } from './types';

export const THScanAndPayView: FC<ITHScanAndPayViewProps> = ({
  addPaymentMethodButtonText,
  currentView,
  isLoading,
  isUpdating,
  nonSelectedPaymentMethods,
  openAddPaymentMethodModal,
  scanAndPayTextContent,
  selectedPaymentMethod,
  toggleScanAndPay,
  updateScanAndPayPaymentMethod,
}) => {
  const ScanAndPayToggle = (
    <Toggle
      checked={currentView === ScanAndPayViews.ACTIVE}
      onChange={toggleScanAndPay}
      data-testid="scan-and-pay-toggle"
    />
  );

  if (isLoading) {
    return <ScanAndPayLayoutSkeleton />;
  }

  if (currentView === ScanAndPayViews.NO_PAYMENT_METHOD) {
    return (
      <NoPaymentMethod
        title={scanAndPayTextContent.header ?? ''}
        bodyText={scanAndPayTextContent.noPaymentMethodStateBody}
        addPaymentMethodButtonText={addPaymentMethodButtonText}
        openAddPaymentMethodModal={openAddPaymentMethodModal}
        data-testid="scan-and-pay-no-payment-method"
      />
    );
  }

  let LayoutContent: JSX.Element | null = null;

  if (isUpdating || (currentView === ScanAndPayViews.ACTIVE && !selectedPaymentMethod)) {
    LayoutContent = <ScanAndPayContentSkeleton />;
  } else if (currentView === ScanAndPayViews.INACTIVE) {
    LayoutContent = <StyledSanityBlockContent content={scanAndPayTextContent.inactiveStateBody} />;
  } else if (currentView === ScanAndPayViews.ACTIVE) {
    LayoutContent = (
      <PaymentMethodSelect
        selectedMethod={selectedPaymentMethod}
        nonSelectedMethods={nonSelectedPaymentMethods}
        onOptionClick={updateScanAndPayPaymentMethod}
        hoverTheme={HoverTheme.LIGHT}
        onNavigateClick={openAddPaymentMethodModal}
      />
    );
  }

  return (
    <ScanAndPayLayout
      data-testid="scan-and-pay-layout"
      title={scanAndPayTextContent.header ?? ''}
      headerElement={ScanAndPayToggle}
    >
      {LayoutContent}
    </ScanAndPayLayout>
  );
};
